import _ from 'lodash';

export default class ProductInCart {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.codeSupplier = _.get(data, 'codeSupplier', '');
    this.name = _.get(data, 'name', '');
    this.packaging = _.get(data, 'packaging', '');
    this.unit = _.get(data, 'unit', '');
    this.uc = _.get(data, 'uc', '');
    this.supplier = _.get(data, 'supplier', '');
    this.price = _.get(data, 'price', '');
    this.quantity = _.get(data, 'quantity', '');
    this.ean = _.get(data, 'ean', '');
    this.conditionning = _.get(data, 'conditionning', 1);
  }
}
